module.exports = __webpack_public_path__ + "static/media/ClanOffcPro-Book.ad203927.woff";